exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-client .sb-health-insurance-img{width:100%}.input-search{margin-left:auto}.captions-group{margin-top:20px}.grid-captions{display:grid;grid-template-columns:1fr 1fr 1fr}.captions-group>div{font-size:14px;margin-top:4px}.grid-captions>div:last-child{grid-column-end:span 3}.chart-caption{width:12px;height:12px;margin-top:3px;margin-right:5px}.inputs-container{display:grid;grid-template-columns:repeat(4,1fr);gap:20px}.md-text:first-letter{text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/client/client.scss
// module id = 704
// module chunks = 0